import { useEffect, useState } from 'react';
import { getMemberUpdate } from 'src/shared/services/memberUpdateService';

/** Returns the number of pending member updates */
export const useMemberUpdatesBadge = () => {
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    getMemberUpdate(0, 1, 'memberUpdate_id', 'desc')
      .then((res) => {
        setPendingCount(res.data.totalItems);
      })
      .catch(() => undefined);
  }, []);

  return pendingCount;
};
